import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class dataStatisticsState extends baseState {
  // 设备使用情况统计
  @observable deviceData = {};
  @action
  setDeviceData = data => this.deviceData = data;
  getDeviceData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.DEVICE_USE.DATA,
      method: 'get',
      setState: this.setDeviceData,
      data,
    });
  }

  // 基础数据（人员，设备，告警基本数据）
  @observable basisData = {};
  @action
  setBasisData = data => this.basisData = data;
  getBasisData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.BASIS_DATA,
      method: 'get',
      setState: this.setBasisData,
      data,
    });
  }

  // 设备状态
  @observable statusData = [];
  @action
  setStatusData = data => this.statusData = data;
  getStatusData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.DEVICE_STATUS_DATA,
      method: 'get',
      setState: this.setStatusData,
      data,
    });
  }

  // 血氧统计
  @observable bloodOxygenData = {};
  @action
  setBloodOxygenData = data => this.bloodOxygenData = data;
  getBloodOxygenData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.BLOOD_OXYGEN_DATA,
      method: 'get',
      setState: this.setBloodOxygenData,
      data,
    });
  }

  // 血糖统计
  @observable bloodSugarData = {};
  @action
  setBloodSugarData = data => this.bloodSugarData = data;
  getBloodSugarData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.BLOOD_SUGAR_DATA,
      method: 'get',
      setState: this.setBloodSugarData,
      data,
    });
  }

  // 指标异常统计 
  @observable standardData = [];
  setStandardData = data => {
    this.standardData = data;
  };
  getStandardData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.STANDARD_DATA,
      method: 'get',
      setState: this.setStandardData,
      data,
    });
  }

  // 健康状况分布
  @observable healthyData = [];
  @action
  setHealthyData = data => this.healthyData = data;
  getHealthyData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.HEALTHY_DATA,
      method: 'get',
      setState: this.setHealthyData,
      data,
    });
  }

  // 实时监测数据
  @observable monitorData = [];
  @action
  setMonitorData = data => this.monitorData = data;
  getMonitorData = data => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.MONITOR_DATA,
      method: 'get',
      setState: this.setMonitorData,
      data,
    });
  }

  getDeviceDetail = id => {
    return this.fetch({
      url: apiUrl.DATA_STATISTICS.BIG_DATA.DEVICE_DETAIL + id,
      method: 'get',
      data: { id }
    });
  }

}
